import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Card from '@material-ui/core/Card'
import Box from '@material-ui/core/Box'
import Avatar from 'ui/components/avatar'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import useStyles from './styles'
import useTranslation from 'hooks/useTranslations'
import { useTheme } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const CompanyCard = props => {
  const { avatarImage, avatarName, nif, company, decorative } = props

  const t = useTranslation()

  const classes = useStyles()

  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Card
      className={clsx(classes.root, decorative && classes.hasDecorative)}
      elevation={1}
    >
      <Box className={classes.avatarWrapper}>
        <Avatar
          size={isSmall ? 'medium' : 'large'}
          className={classes.avatar}
          src={avatarImage}
        >
          {avatarName}
        </Avatar>
      </Box>
      <CardContent className={classes.content}>
        <Typography variant="body2" component="p" gutterBottom>
          {t('home:nif')} {nif}
        </Typography>
        <Typography variant="h1" component="h2">
          {company}
        </Typography>
        {decorative ? (
          <img src={decorative} alt="" className={classes.decorative} />
        ) : null}
      </CardContent>
    </Card>
  )
}

CompanyCard.propTypes = {
  avatarImage: PropTypes.node,
  avatarName: PropTypes.string,
  nif: PropTypes.string,
  company: PropTypes.string.isRequired,
  decorative: PropTypes.node,
}

export default CompanyCard
